import axiosHandler from '../../Intersepter/axiosInstance'

//   Sends an OTP to the specified contact number or email.
export const sendOtp = async (data) => {
  try {
    const response = await axiosHandler.post(`/auth/send-otp`, data);
    return response.data; 
  } catch (error) {
    console.error("Error sending OTP:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
};

//verify otp
export const verifyOtp = async (data) => {
    try {
      const response = await axiosHandler.post(`/auth/verify-otp`, data);
      return response.data; 
    } catch (error) {
      console.error("Error verify OTP:", error.response?.data || error.message);
      throw error.response?.data || error;
    }
  };
